export const strings={
    asanDarman:'آسان درمان'
}
